import { useTranslation } from 'react-i18next';
import { FiAlertTriangle, FiX } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

export default function ImpersonationBanner() {
  const { t } = useTranslation('admin');
  const auth = useAuth();
  const impersonation = auth?.impersonation;
  const user = auth?.user;
  const endImpersonation = auth?.endImpersonation;
  const isEndingImpersonation = auth?.isEndingImpersonation;
  const isTargetUnverified = user?.is_verified === false || user?.email_verified_at === null;

  if (!impersonation) return null;

  return (
    <div
      role="status"
      className="sticky top-0 z-[100] flex flex-wrap items-center justify-center gap-3 border-b border-amber-500/30 bg-amber-500 px-4 py-2.5 text-center text-sm font-semibold text-[#061542] shadow-sm"
    >
      <FiAlertTriangle className="h-4 w-4 shrink-0" aria-hidden />
      <span>
        {t('users.impersonation.banner', {
          name: impersonation.target_display_name,
          role: impersonation.target_role,
        })}
      </span>
      {isTargetUnverified && (
        <span className="inline-flex items-center rounded-full bg-white/90 px-2.5 py-1 text-xs font-black text-red-700 ring-1 ring-red-200">
          {t('users.impersonation.not_verified')}
        </span>
      )}
      <button
        type="button"
        onClick={() => endImpersonation()}
        disabled={isEndingImpersonation}
        className="inline-flex items-center gap-1.5 rounded-lg bg-[#061542] px-3 py-1.5 text-xs font-bold text-white transition hover:bg-[#061542]/90 disabled:opacity-60"
      >
        <FiX className="h-3.5 w-3.5" aria-hidden />
        {t('users.impersonation.end_session')}
      </button>
    </div>
  );
}
